import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class LoadResourcesWithBeforePriorityAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        await this.resourceManager.loadResourcesWithBeforePriority();
    }

    getName(): string {
        return 'LoadResourcesWithBeforePriorityAct';
    }
}